module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/tip.f41d79c1.svg";